/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Dashboard_TitleInputs */

const en_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const es_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel`)
};

const fr_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord`)
};

const de_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const ja_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダッシュボード`)
};

const zh_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仪表板`)
};

const ar_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة التحكم`)
};

const id_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dasbor`)
};

const it_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dashboard`)
};

const ru_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Панель управления`)
};

const pt_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel`)
};

const ko_seller_dashboard_title = /** @type {(inputs: Seller_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대시보드`)
};

/**
* | output |
* | --- |
* | "Dashboard" |
*
* @param {Seller_Dashboard_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_dashboard_title = /** @type {((inputs?: Seller_Dashboard_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Dashboard_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_dashboard_title(inputs)
	if (locale === "es") return es_seller_dashboard_title(inputs)
	if (locale === "fr") return fr_seller_dashboard_title(inputs)
	if (locale === "de") return de_seller_dashboard_title(inputs)
	if (locale === "ja") return ja_seller_dashboard_title(inputs)
	if (locale === "zh") return zh_seller_dashboard_title(inputs)
	if (locale === "ar") return ar_seller_dashboard_title(inputs)
	if (locale === "id") return id_seller_dashboard_title(inputs)
	if (locale === "it") return it_seller_dashboard_title(inputs)
	if (locale === "ru") return ru_seller_dashboard_title(inputs)
	if (locale === "pt") return pt_seller_dashboard_title(inputs)
	return ko_seller_dashboard_title(inputs)
});